import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import NavbarBrand from './sections/NavbarBrand';
import NavbarLinks from './sections/NavbarLinks';
import NavbarMobileMenu from './sections/NavbarMobileMenu';
import NavbarProgressBar from './sections/NavbarProgressBar';

const LandingNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const whatsappLink =
    "https://wa.me/919225296763?text=Hello%20Trrip%20Team!%20I'd%20like%20to%20book%20a%20demo%20for%20the%20Agent%20Portal.";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (id) => {
    const wasMobileOpen = isMobileMenuOpen;
    setIsMobileMenuOpen(false);

    const performScroll = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (wasMobileOpen) {
      setTimeout(performScroll, 220);
    } else {
      performScroll();
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled || isMobileMenuOpen
          ? 'py-2.5 sm:py-3 bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-200'
          : 'py-3.5 sm:py-5 bg-transparent'
      }`}
    >
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-3.5 sm:px-6 md:px-8 flex items-center justify-between">
        {/* Logo & Navigation Links */}
        <div className="flex items-center gap-4 sm:gap-8 lg:gap-12">
          <NavbarBrand />
          <NavbarLinks isScrolled={isScrolled} onNavigate={scrollToSection} />
        </div>

        {/* Right CTA & Mobile Toggle */}
        <div className="flex items-center gap-2.5 sm:gap-3">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className={`px-3.5 sm:px-5 md:px-6 py-1.5 sm:py-2 md:py-2.5 rounded-lg font-bold text-xs sm:text-sm tracking-wide transition-all duration-300 backdrop-blur-sm whitespace-nowrap ${
              isScrolled
                ? 'bg-[#067978] text-white hover:bg-[#056362] shadow-md'
                : 'bg-[#067978] text-white hover:bg-[#056362] shadow-[0_0_15px_rgba(6,121,120,0.3)] hover:shadow-[0_0_20px_rgba(6,121,120,0.5)]'
            }`}
          >
            Book a Demo
          </a>

          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-[#067978] hover:bg-slate-100/80 rounded-lg transition-colors cursor-pointer border-none flex items-center justify-center"
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Dropdown Menu */}
      <NavbarMobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        onNavigate={scrollToSection}
        whatsappLink={whatsappLink}
      />

      {/* Scroll Progress Bar */}
      <NavbarProgressBar />
    </nav>
  );
};

export default LandingNavbar;
